import React from 'react';

import AddUser from 'components/pages/Home/UserTab/AddUser';

const UserMiddleContent = () => <AddUser />;

export default UserMiddleContent;
